
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { 
  FileText, 
  List, 
  Home, 
  ChevronLeft, 
  ChevronRight, 
  PanelRight, 
  ListCheck,
  Wallet,
  Users
} from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";

export const AdminSidebar = () => {
  const { state, toggleSidebar } = useSidebar();
  const isCollapsed = state === "collapsed";
  const location = useLocation();

  const menuItems = [
    {
      title: "หน้าหลัก",
      url: "/",
      icon: Home,
    },
    {
      title: "รายงานพัฒนาการนักเรียน",
      url: "/admin",
      icon: FileText,
    },
    {
      title: "รายชื่อนักเรียนทั้งหมด",
      url: "/admin/students",
      icon: Users,
    },
    {
      title: "ตรวจชีท",
      url: "/admin/worksheet-check",
      icon: ListCheck,
    },
    {
      title: "เงินเดือนครู",
      url: "/admin/teacher-salary",
      icon: Wallet,
    },
    {
      title: "ตารางเฉพาะกิจ",
      url: "/admin/jobs",
      icon: List,
    },
    {
      title: "Admin Logs",
      url: "/admin/logs",
      icon: List,
    },
  ];

  return (
    <Sidebar>
      <SidebarHeader className="pb-0">
        <div className="px-3 py-2">
          <h2 className="text-lg font-semibold tracking-tight">แผงควบคุมผู้ดูแลระบบ</h2>
          <p className="text-sm text-muted-foreground">Admin Dashboard</p>
        </div>
        <button
          onClick={toggleSidebar}
          className="absolute right-2 top-2 p-1 rounded-full hover:bg-muted"
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? (
            <ChevronRight className="h-4 w-4" />
          ) : (
            <ChevronLeft className="h-4 w-4" />
          )}
        </button>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>เมนู</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild tooltip={item.title}>
                    <NavLink
                      to={item.url}
                      className={({ isActive }) => 
                        isActive || location.pathname === item.url ? "data-[active=true]" : ""
                      }
                    >
                      <item.icon className="h-5 w-5" />
                      <span>{item.title}</span>
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter className="py-2">
        <div className="px-3 text-xs text-muted-foreground">
          {new Date().getFullYear()} © Admin Panel
        </div>
      </SidebarFooter>
      <SidebarRail />
      {isCollapsed && (
        <Button
          variant="secondary"
          size="icon"
          onClick={toggleSidebar}
          className="fixed top-4 left-[3.2rem] z-20 shadow-md border bg-background"
          aria-label="Expand sidebar"
        >
          <PanelRight className="h-4 w-4" />
        </Button>
      )}
    </Sidebar>
  );
};
